import Button from "../../../../common/button";
import AboutStyleWrapper from "./About.style";
import { FaCheck } from "react-icons/fa";
import aboutImage from "../../../../assets/images/about/about-us-01.png";

const About = () => {
  return (
    <AboutStyleWrapper>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="about_left_content">
              <h2 className="about_title">
                leading chain , crypto & ico <br /> devlopment services
              </h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. enim ad minim veniam, quis exercitation ullamco laboris nisi ut aliquip ex .
              </p>
              <div className="about_list">
                <div className="about_list_item">
                  <FaCheck />
                  <span>Join 10m+ users buying and selling 100+ cryptocurrencies at true cost</span>
                </div>
                <div className="about_list_item">
                  <FaCheck />
                  <span>Spend with the Crypto.com Visa Card and get up to 8% back</span>
                </div>
                <div className="about_list_item">
                  <FaCheck />
                  <span>Grow your portfolio by earning up to 14% interest on your crypto assets</span>
                </div>
              </div>
              <Button lg variant="outline" className="read_btn">
                Read More
              </Button>
            </div>
          </div>
          <div className="col-md-6">
            <div className="about_right_content">
              <img src={aboutImage} alt="about"/>
            </div>
          </div>
        </div>
      </div>
    </AboutStyleWrapper>
  );
};

export default About;
